import { IconButton, TableRow } from '@mui/material';
import { Box } from '@mui/system';
import styled from 'styled-components';
import { COLORS } from 'theme/colors';

export const DetailsContainer = styled(Box)`
  margin: 1.25rem auto 0 auto;
  display: grid;
  grid-template-columns: minmax(min-content, 280px) minmax(min-content, 1200px);
  gap: 0px 48px;
`;

export const DetailsWrapper = styled(Box)`
  width: 100%;
  margin: auto;
  margin-top: 0;
  padding-right: 1rem;
  padding-bottom: 2rem;
`;

export const TitleRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding-top: 1.5rem;
  padding-bottom: 0.75rem;
`;

export const Title = styled.h1`
  font-family: sans-serif;
  font-size: 1.35rem;
  line-height: 1.1;
  font-weight: 700;
  margin: 0;
`;

export const SideTableContainer = styled(Box)`
  && {
    margin-top: 4.4rem;
    margin-bottom: 0.75rem;
    padding-left: 1rem;
    min-height: 280px;
  }
`;

export const ToolbarContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 0.5rem;
  margin-top: 0.5rem;
`;

export const ResizeButton = styled(IconButton)`
  && {
    border: 1px solid rgba(0, 0, 0, 0.23);
    border-radius: 4px;
    padding: 2px;
    height: 100%;
  }
`;

export const ServiceRow = styled(TableRow)<{ $active?: boolean }>`
  cursor: pointer;
  ${({ $active }) => $active && `background-color: ${COLORS.GRAY_1};`}
`;

export const inlineInputSx = {
  width: '100%',
  '& .MuiInputBase-root': {
    fontSize: '0.9rem',
    fontWeight: 500,
    padding: '0 4px',
  },
  '& .MuiInputBase-input': {
    padding: '2px 4px',
  },
  '& .MuiOutlinedInput-notchedOutline': {
    borderColor: 'rgba(0,0,0,0.15)',
  },
} as const;

export const BlankRect = styled.span`
  display: inline-block;
  width: 2rem;
  height: 1rem;
  background-color: #e0e0e0;
  border-radius: 4px;
  vertical-align: middle;
  margin-left: 4px;
  margin-right: 4px;
`;
